import {clearText, isMobile} from 'react-lf-tools'
import {buttonColor, textBodyColor} from '../../../metrics.module.scss'
import {smoothScrolling} from '../../../utils/utils.jsx'

import './categorys.scss'

const Categorys = ({categorys, idGroup}) => {

    return <div className={'categorys'} id={'scroll-categorys'}>
        {categorys.map(c => <div
            className={'div-category'}
            style={(idGroup === clearText(c)) ? {borderColor: buttonColor} : {}}
            key={c} id={`item-${clearText(c)}`}
            onClick={() => smoothScrolling(c, 50, (isMobile() ? 90 : 65))}>
            <label
                style={(idGroup === clearText(c)) ? {color: buttonColor} : {color: textBodyColor}}
                className={'category'}>
                {c}
            </label>
        </div>)}
    </div>
}

export default Categorys
